import { render, staticRenderFns } from "./Son_Text.vue?vue&type=template&id=4176900c&scoped=true&"
import script from "./Son_Text.vue?vue&type=script&lang=js&"
export * from "./Son_Text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4176900c",
  null
  
)

export default component.exports